/**
 * A DataCollection instance for managing a collection of person data.
 *
 * @type {webix.DataCollection}
 */
export const persons = new webix.DataCollection({
    /**
     * URL to fetch the person data in JSON format.
     *
     * @type {string}
     */
    url: 'data/persons.json',
});

// FILE DOCUMENTED
